"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const userQueryHelpers_1 = require("./common/userQueryHelpers");
function getUserByQuery(query) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let users = [];
        let total = 0;
        if (query.from || query.from === 0) {
            query.size = query.size || query.size === 0 ? query.size : 100;
            const elasticsearchResult = yield userQueryHelpers_1.getUsersUsingQuery(query);
            users = elasticsearchResult.users;
            total = elasticsearchResult.total;
        }
        else {
            query.size = query.size || query.size === 0 ? query.size : 100;
            const elasticsearchResult = yield userQueryHelpers_1.getUsersUsingQuery(query, '30s');
            const { scrollId, total: resultCount } = elasticsearchResult;
            total = resultCount;
            // Fetching remaing batch of users using scroll
            users = yield userQueryHelpers_1.fetchFromScroll({
                total,
                scrollId,
                users: elasticsearchResult.users
            });
        }
        return { users, total };
    });
}
exports.getUserByQuery = getUserByQuery;
//# sourceMappingURL=getUserByQuery.js.map